"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MeetingSessionStatusCode_1 = require("../meetingsession/MeetingSessionStatusCode");

var DefaultSDP_1 = require("../sdp/DefaultSDP");

var BaseTask_1 = require("./BaseTask");
/*
 * [[CreateSDPTask]] asynchronously calls [[createOffer]] on peer connection.
 */


var CreateSDPTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(CreateSDPTask, _BaseTask_1$default);

  var _super = _createSuper(CreateSDPTask);

  function CreateSDPTask(context) {
    var _this;

    _classCallCheck(this, CreateSDPTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'CreateSDPTask';
    return _this;
  }

  _createClass(CreateSDPTask, [{
    key: "cancel",
    value: function cancel() {
      // Just in case. The baseCancel behavior should prevent this.

      /* istanbul ignore else */
      if (this.cancelPromise) {
        var error = new Error("canceling ".concat(this.name()));
        this.cancelPromise(error);
        delete this.cancelPromise;
      }
    }
  }, {
    key: "sessionUsesAudio",
    value: function sessionUsesAudio() {
      var _a, _b;

      return !!((_b = (_a = this.context.meetingSessionConfiguration) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.audioHostURL);
    }
  }, {
    key: "sessionUsesVideo",
    value: function sessionUsesVideo() {
      var enabled = true;
      var sending;

      if (this.context.transceiverController.useTransceivers()) {
        sending = this.context.transceiverController.hasVideoInput();
      } else {
        sending = this.context.videoTileController.hasStartedLocalVideoTile();
      }

      var receiving = !!this.context.videosToReceive && !this.context.videosToReceive.empty();
      var usesVideo = enabled && (sending || receiving);
      this.context.logger.info("uses video: ".concat(usesVideo, " (enabled: ").concat(enabled, ", sending: ").concat(sending, ", receiving: ").concat(receiving, ")"));
      return usesVideo;
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var offerOptions;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                offerOptions = {
                  offerToReceiveAudio: this.sessionUsesAudio(),
                  offerToReceiveVideo: this.sessionUsesVideo()
                };
                this.logger.info("peer connection offerOptions: ".concat(JSON.stringify(offerOptions)));
                _context2.next = 4;
                return new Promise(function (resolve, reject) {
                  return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    var error;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            this.cancelPromise = function (error) {
                              reject(error);
                            };

                            _context.prev = 1;
                            _context.next = 4;
                            return this.context.peer.createOffer(offerOptions);

                          case 4:
                            this.context.sdpOfferInit = _context.sent;
                            this.context.logger.info('peer connection created offer');

                            if (!this.context.previousSdpOffer) {
                              _context.next = 12;
                              break;
                            }

                            if (!new DefaultSDP_1.default(this.context.sdpOfferInit.sdp).videoSendSectionHasDifferentSSRC(this.context.previousSdpOffer)) {
                              _context.next = 12;
                              break;
                            }

                            error = new Error("canceling ".concat(this.name(), " due to the meeting status code: ").concat(MeetingSessionStatusCode_1.default.IncompatibleSDP));
                            this.context.previousSdpOffer = null;
                            reject(error);
                            return _context.abrupt("return");

                          case 12:
                            resolve();
                            _context.next = 18;
                            break;

                          case 15:
                            _context.prev = 15;
                            _context.t0 = _context["catch"](1);
                            reject(_context.t0);

                          case 18:
                            _context.prev = 18;
                            delete this.cancelPromise;
                            return _context.finish(18);

                          case 21:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this, [[1, 15, 18, 21]]);
                  }));
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return CreateSDPTask;
}(BaseTask_1.default);

exports.default = CreateSDPTask;